/* --------------------------------------------------------------------------------------
   settingsPopup.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const settingsPopupComponent = {
  template: require('./settingsPopup.html'),
  bindings: {
    display: '=',
  },
  controllerAs: 'vm',
  controller: class settingsPopupCtrl {
    /*@ngInject*/
    constructor(commonService, expensesService, sessionDataService) {
      this.commonService = commonService
      this.expensesService = expensesService
      this.sessionDataService = sessionDataService
    }
    $onInit() {
      this.expenses = this.expensesService.getExpensesAmounts(
        this.sessionDataService.user.ID
      )
      this.enableExpenseToggle = this.expenses.enabled
      this.screenSize = this.commonService.getScreenSize()
      setTimeout(() => {
        this.iScroll = angular.element('#main-settings-scroll').xrxscrollable('getIScroll')
      }, 1000);
    }
    ok() {
      this.validation = {}
      this.validation.print = Number(this.expenses.print)
      this.validation.scan = Number(this.expenses.scan)

      if (this.enableExpenseToggle && !this.validation.print && !this.validation.scan) {
        angular.element('#expense-validation-banner').xrxbanner('call')
        this.commonService.updateView()
      } else if (
        this.enableExpenseToggle &&
        (!this.validation.print || !this.validation.scan)
      ) {
        this.missingValue = true
      } else {
        this.expenses.enabled = this.enableExpenseToggle
        this.expensesService.setExpensesAmounts(this.expenses)
        this.display = false
      }
    }
    cancel() {
      this.enableExpenseToggle = this.expenses.enabled
      this.display = false
    }
    alertClosed() {
      this.expensesService.setExpensesAmounts(this.expenses)
      this.missingValue = false
      this.display = false
      this.commonService.updateView()
    }
    clearScanIfZero() {
      if (this.expenses.scan == '0.00') {
        this.expenses.scan = ''
        this.commonService.updateView()
      }
    }
    clearPrintIfZero() {
      if (this.expenses.print == '0.00') {
        this.expenses.print = ''
        this.commonService.updateView()
      }
    }
    scanInputClicked() {
      setTimeout(() => {
        if (this.screenSize == 7 && this.iScroll.y > -80) {
          this.iScroll.scrollTo(0, -80)
        }
      }, 650);
    }
    scanInputCanceled() {
      setTimeout(() => {
        this.iScroll.refresh();
      }, 0);
    }
    scanInputAccepted() {
      setTimeout(() => {
        this.iScroll.refresh();
      }, 0);
    }
    printInputClicked() {
      setTimeout(() => {
        if (this.screenSize == 7 && this.iScroll.y > -80) {
          this.iScroll.scrollTo(0, -80)
        }
      }, 650);
    }
    printInputCanceled() {
      setTimeout(() => {
        this.iScroll.refresh();
      }, 0);
    }
    printInputAccepted() {
      setTimeout(() => {
        this.iScroll.refresh();
      }, 0);
    }
    toggleExpenseTrackingEnabled() {
      this.enableExpenseToggle = !this.enableExpenseToggle
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/components/settingsPopup.component.js